/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import { addMinutes, format } from "date-fns";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
// Dashboard components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDCard from "components/MDCard";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";

import { parseISO } from "date-fns";
import DataTable from "examples/Tables/DataTable";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import Modal from "@mui/material/Modal";

import Alert from "@mui/material/Alert";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";

// Notification
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// @mui material icons
import CloseIcon from "@mui/icons-material/Close";

// Functions from store
import {
  approveInvoice,
  createDynamicColumn,
  getDynamicColumn,
  getSubModulesByRoleId,
  rejectInvoice,
  unReviewInvoice,
} from "../../../store";

import "../../../index.css";

// config file
import Config from "../../../config/index";

// Cookies
import { Backdrop, CircularProgress } from "@mui/material";
import Cookies from "universal-cookie";

const cookies = new Cookies();
const desLength = Config.descriptionLength;

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 350,
  boxShadow: 24,
  p: 0,
  pt: 3,
};

const styleForCreatePo = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  boxShadow: 24,
  p: 0,
  pt: 3,
  width: { xs: 350, lg: 750 },
  height: "fit-content",
  maxHeight: "90%",
  overflow: "scroll",
};

const deleteStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 350,
  boxShadow: 24,
  p: 2,
  pt: 3,
};

const styleForRelease = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 380,
  color: "black",
  boxShadow: 24,
  p: 2,
  pt: 3,
};

const styleForColumnReorder = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 380,
  color: "black",
  // border: "2px solid #000",
  boxShadow: 24,
  p: 2,
  pt: 3,
};

const PendingReview = ({
  getSubModulesByRoleId,
  getSubModulesByRoleIdReducer,
  unReviewInvoice,

  approveInvoice,
  rejectInvoice,
  unReviewInvoiceReducer,
  getDynamicColumn,
  createDynamicColumn,
  getDynamicColumnReducer,
}) => {
  let loginDetails = cookies.get("loginDetailsForWMS");

  let jwtToken = loginDetails?.jwt;
  let roleId = loginDetails?.data?.roleId;
  let userId = loginDetails?.data?.userId;
  let roleName = loginDetails?.data?.roleName;

  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);

  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);

  const subModuleId = "565db19b-248e-453f-9766-bca7c68b9090";

  let dynamicColumnDetails = cookies.get("dynamic-column-data");

  let pendingReviewAccess = modulesData.find(
    (moduleId) => moduleId.moduleId == "565db19b-248e-453f-9766-bca7c68b9090",
  );

  let approveInvoiceAccess = pendingReviewAccess
    ? pendingReviewAccess.actionId.includes(
        "008529f7-aec0-44bc-a701-66c1969db36e",
      )
    : null;

  let rejectInvoiceAccess = pendingReviewAccess
    ? pendingReviewAccess.actionId.includes(
        "dd014304-48de-40bc-8da2-290e8bf470a7",
      )
    : null;

  let ViewInvoiceAccess = pendingReviewAccess
    ? pendingReviewAccess.actionId.includes(
        "c2c634aa-1de2-4e1c-ae3f-f1458853f88e",
      )
    : null;

  const [pageNo, setPageNo] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchObject, setSearchObject] = useState(JSON.stringify({}));
  const [paginationObj, setPaginationObj] = useState({});
  const [errorMsgFromApi, setErrorMsgFromApi] = useState("");

  const importPageNo = (pageIndex) => {
    setPageNo(pageIndex === -1 ? pageNo : pageIndex);
  };

  const importRowsPerPage = (pageSize) => {
    setRowsPerPage(pageSize);
  };

  const importSearch = (globalFilter) => {
    setSearchObject(globalFilter ? JSON.stringify(globalFilter) : "");
  };

  useEffect(() => {
    unReviewInvoice(pageNo, rowsPerPage, searchObject, jwtToken);
  }, [roleName, pageNo, rowsPerPage, searchObject]);

  const [state, setState] = useState({
    columns: [
      { Header: "PO No.", accessor: "purchaseOrderNumber" },
      { Header: "PO LineNo.", accessor: "purchaseOrderLineNumber" },
      { Header: "Invoice Id", accessor: "invoiceId" },
      { Header: "Invoice No", accessor: "invoiceNo" },
      { Header: "Due Date", accessor: "dueDate" },
      { Header: "Total Amount", accessor: "totalAmount" },
      // { Header: "Status", accessor: "status" },
      { Header: "Create Date", accessor: "cd" },

      {
        Header: "Action",
        accessor: "action",
        align: "center",
        cannotSearch: true,
      },
    ],
    rows: [],
  });

  const { columns, rows } = state;

  const [isErrorForCreateOrder, setIsErrorForCreateOrder] = useState(false);
  const [isSuccessForCreateOrder, setIsSuccessForCreateOrder] = useState(false);

  const [invoiceId, setInvoiceId] = useState(null);

  useEffect(() => {
    if (isErrorForCreateOrder) {
      setTimeout(() => {
        setIsErrorForCreateOrder(false);
      }, 3000);
    }
  }, [isErrorForCreateOrder]);

  useEffect(() => {
    if (isSuccessForCreateOrder) {
      setTimeout(() => {
        setIsSuccessForCreateOrder(false);
      }, 3000);
    }
  }, [isSuccessForCreateOrder]);
  const [isErrorRelease, setIsErrorRelease] = useState(false);
  const [isSuccessRelease, setIsSuccessRelease] = useState(false);

  useEffect(() => {
    if (isErrorRelease) {
      setTimeout(() => {
        setIsErrorRelease(false);
      }, 3000);
    }
  }, [isErrorRelease]);

  useEffect(() => {
    if (isSuccessRelease) {
      setTimeout(() => {
        setIsSuccessRelease(false);
      }, 3000);
    }
  }, [isSuccessRelease]);

  const [loading, setLoading] = useState(true);

  // useEffect(() => {
  //   // let tempAsset = [];

  //   const listState = unReviewInvoiceReducer

  //   const data = Array.isArray(listState?.invoices) ? listState.invoices : [];

  //   setPaginationObj(listState?.pagination);
  //   setLoading(listState?.loading);

  //   const rows = data.map((inv) => {

  //     const rawDue = inv?.dueDate ? parseISO(inv.dueDate) : null;
  //     const localDue = rawDue
  //       ? addMinutes(rawDue, rawDue.getTimezoneOffset())
  //       : null;
  //     const dueDateText = localDue ? format(localDue, "do MMMM yyyy") : "NA";

  //     const rawCd = inv?.cd ? parseISO(inv.cd) : null;
  //     const localCd = rawCd
  //       ? addMinutes(rawCd, rawCd.getTimezoneOffset())
  //       : null;
  //     const createdDateText = localCd ? format(localCd, "do MMMM yyyy") : "NA";

  //     return {
  //       invoiceId: inv.invoiceId,
  //       purchaseOrderNumber: inv.purchaseOrderNumber,
  //       purchaseOrderLineNumber: inv.purchaseOrderLineNumber,
  //       invoiceNo: inv.invoiceNo,
  //       totalAmount: inv.totalAmount,
  //       dueDate: dueDateText,
  //       cd: createdDateText,

  //       // status: statusText,
  //       action: (
  //         <div
  //           style={{
  //             display: "flex",
  //             flexDirection: "row",
  //             alignItems: "center",
  //             gap: "4px",
  //           }}
  //         >
  //           { approveInvoiceAccess && (
  //           <MDButton
  //             variant="gradient"
  //             color="success"
  //             iconOnly
  //             type="button"
  //             onClick={() => openSingleVendorDecisionModal(inv, "Approve")}
  //           >
  //             <Icon>check_circle</Icon>
  //           </MDButton>
  //           )}
  //           {rejectInvoiceAccess && (
  //           <MDButton
  //             variant="gradient"
  //             color="error"
  //             iconOnly
  //             type="button"
  //             onClick={() => openSingleVendorDecisionModal(inv, "REJECT")}
  //           >
  //             <Icon>cancel</Icon>
  //           </MDButton>
  //           )}
  //         </div>
  //       ),
  //     };
  //   });

  //   setState((prev) => ({ ...prev, rows }));
  // }, [roleName, reviewInvoiceReducer, unReviewInvoiceReducer, ViewInvoiceAccess]);

  useEffect(() => {
    let tempRows = [];

    const invoicesData = Array.isArray(unReviewInvoiceReducer.data?.data)
      ? unReviewInvoiceReducer.data.data
      : [];

    setLoading(unReviewInvoiceReducer.loading);

    setPaginationObj(unReviewInvoiceReducer.data?.pagination);

    invoicesData.forEach((inv) => {
      const rawDue = inv?.dueDate ? parseISO(inv.dueDate) : null;
      const localDue = rawDue
        ? addMinutes(rawDue, rawDue.getTimezoneOffset())
        : null;
      const dueDateText = localDue ? format(localDue, "do MMMM yyyy") : "NA";

      const rawCd = inv?.cd ? parseISO(inv.cd) : null;
      const localCd = rawCd
        ? addMinutes(rawCd, rawCd.getTimezoneOffset())
        : null;
      const createdDateText = localCd ? format(localCd, "do MMMM yyyy") : "NA";

      const rowObject = {
        invoiceId: inv.invoiceId,
        purchaseOrderNumber: inv.purchaseOrderNumber,
        purchaseOrderLineNumber: inv.purchaseOrderLineNumber,
        invoiceNo: inv.invoiceNo,
        totalAmount: inv.totalAmount,
        dueDate: dueDateText,
        cd: createdDateText,
        action: (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: "4px",
            }}
          >
            {approveInvoiceAccess && (
              <Tooltip title="Approve">
                <MDButton
                  tooltip="Approve"
                  variant="gradient"
                  color="success"
                  size="small"
                  iconOnly
                  type="button"
                  onClick={() => openSingleVendorDecisionModal(inv, "Approve")}
                >
                  <Icon>check_circle</Icon>
                </MDButton>
              </Tooltip>
            )}
            {rejectInvoiceAccess && (
              <Tooltip title="Reject">
                <MDButton
                  tooltip="Reject"
                  variant="gradient"
                  color="error"
                  size="small"
                  iconOnly
                  type="button"
                  onClick={() => openSingleVendorDecisionModal(inv, "REJECT")}
                >
                  <Icon>cancel</Icon>
                </MDButton>
              </Tooltip>
            )}
          </div>
        ),
      };

      tempRows.push(rowObject);
    });

    setState((prev) => ({ ...prev, rows: tempRows }));
  }, [
    unReviewInvoiceReducer,
    approveInvoiceAccess,
    rejectInvoiceAccess,
    ViewInvoiceAccess,
  ]);

  const [uncheck, setUncheck] = useState(false);
  const [disableButton, setDisableButton] = useState(false);
  const [openclientDecision, setOpenClientDecision] = useState(false);
  const [clientDecisionType, setClientDecisionType] = useState(null);
  const [selectedinvForDecision, setSelectedinvForDecision] = useState(null);
  const [rejectReason, setRejectReason] = useState("");

  const openSingleVendorDecisionModal = (inv, type) => {
    setSelectedinvForDecision(inv);
    setClientDecisionType(type);
    setRejectReason("");
    setOpenClientDecision(true);
  };
  const closeClientDecisionModal = () => setOpenClientDecision(false);

  const confirmVendorDecision = async () => {
    const isReject = clientDecisionType === "REJECT";

    const rejectPayload = {
      invoiceId: String(selectedinvForDecision.invoiceId),
      reason: rejectReason?.trim(),
    };

    const acceptPayload = [
      { invoiceId: String(selectedinvForDecision.invoiceId) },
    ];

    const res = isReject
      ? await rejectInvoice(rejectPayload, jwtToken)
      : await approveInvoice(acceptPayload, jwtToken);

    if (res?.status) {
      toast.success(
        `invoice ${
          clientDecisionType === "Approve" ? "Approved" : "rejected"
        } successfully!`,
      );
      unReviewInvoice(pageNo, rowsPerPage, searchObject, jwtToken);
      closeClientDecisionModal();
    } else {
      toast.error(res?.data?.data?.msg || "Action failed");
    }
  };

  const [selectedOrders, setSelectedOrders] = useState([]);
  const [openVendorBulkModal, setOpenVendorBulkModal] = useState(false);
  const [vendorBulkType, setVendorBulkType] = useState(null);
  const [bulkRejectReason, setBulkRejectReason] = useState("");

  const handleVendorBulk = (type) => {
    if (!selectedOrders.length) {
      toast.error("Select at least one invoice");
      return;
    }
    setVendorBulkType(type);
    setBulkRejectReason("");
    setOpenVendorBulkModal(true);
  };

  const [loadingForDynamicColumn, setLoadingForDynamicColumn] = useState(false);
  useEffect(() => {
    getDynamicColumn(userId, subModuleId, jwtToken);
  }, [userId, subModuleId]);

  const [dynamicColumnData, setDynamicColumnData] = useState("");

  let hiddenColumsDetails = cookies.get("hidden-column-data");
  useEffect(() => {
    let data = getDynamicColumnReducer.dynamicColumn.data
      ? getDynamicColumnReducer.dynamicColumn.data
      : [];

    setDynamicColumnData(data);
    cookies.set("hidden-column-data", JSON.stringify(data?.notVisibleFields), {
      path: "/",
    });

    setTimeout(() => {
      setLoadingForDynamicColumn(true);
    }, 1000);
  }, [getDynamicColumnReducer, loading]);

  const [openCreateColumnReorderModal, setOpenCreateColumnReorderModal] =
    useState(false);

  const handleOpenCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(true);
  };

  const handleCloseCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(false);
  };

  const [isErrorColumnReorder, setIsErrorColumnReorder] = useState(false);
  const [isSuccessColumnReorder, setIsSuccessColumnReorder] = useState(false);

  useEffect(() => {
    if (isErrorColumnReorder) {
      setTimeout(() => {
        setIsErrorColumnReorder(false);
      }, 3000);
    }
  }, [isErrorColumnReorder]);

  useEffect(() => {
    if (isSuccessColumnReorder) {
      setTimeout(() => {
        setIsSuccessColumnReorder(false);
      }, 3000);
    }
  }, [isSuccessColumnReorder]);

  const [isErrorMsgForColumnReorder, setIsErrorMsgForColumnReorder] =
    useState(false);

  const handleDynamicColumn = async () => {
    let res = await createDynamicColumn(dynamicColumnDetails, jwtToken);
    if (res.status) {
      setIsSuccessColumnReorder(true);
      getDynamicColumn(userId, subModuleId, jwtToken);
      unReviewInvoice(pageNo, rowsPerPage, searchObject, jwtToken);
      setTimeout(() => {
        handleCloseCreateColumnReorderModal();
        // window.location.reload();
      }, 2250);
    }
    if (!res.status) {
      setIsErrorColumnReorder(true);
      setIsErrorMsgForColumnReorder(res?.data?.data?.msg);
    }
  };

  // const confirmVendorBulk = async () => {
  //   const payload = selectedOrders.map((order) => ({
  //     purchaseOrderId: order.purchaseOrderId,
  //     reason: vendorBulkType === "REJECT" ? bulkRejectReason : undefined,
  //   }));
  //   const res =
  //     vendorBulkType === "Approve"
  //       ? await approveInvoice(payload, jwtToken)
  //       : await rejectInvoice(payload, jwtToken);

  //   if (res?.status) {
  //     toast.success(
  //       `Selected POs ${
  //         vendorBulkType === "Approve" ? "accepted" : "rejected"
  //       } successfully!`
  //     );
  //     setUncheck(!uncheck);
  //     getVendorPurchaseOrder(
  //       userId,
  //       pageNo,
  //       rowsPerPage,
  //       searchObject,
  //       jwtToken
  //     );
  //     setOpenVendorBulkModal(false);
  //   } else {
  //     toast.error(res?.data?.data?.msg || "Bulk inv's failed");
  //   }
  // };
  return (
    <div>
      <Grid container spacing={6}>
        <Grid item xs={12}>
          <Card>
            <MDBox mt={0}>
              <DataTable
                table={{ columns, rows }}
                isSorted
                tableSearch
                showTotalEntries
                noEndBorder
                loading={loading}
                entriesPerPage={{
                  defaultValue: 5,
                  entries: [5, 10, 15, 20, 25, 30],
                }}
                serverSidePagination
                paginationObj={paginationObj}
                pageNoValue={pageNo}
                rowsPerPageValue={rowsPerPage}
                pageNoProp={importPageNo}
                rowsPerPageProp={importRowsPerPage}
                searchProp={importSearch}
                visibleColumns2={dynamicColumnData?.visibleFields}
                dynamicColumnData={dynamicColumnData}
                options={{ draggable: false }}
                handleOpenCreateColumnReorderModal={
                  handleOpenCreateColumnReorderModal
                }
                subModuleId={subModuleId}
                userId={userId}
                disableButton={disableButton}
                selectionButtonComponent={
                  <div
                    style={{
                      display: "flex",
                      gap: "8px",
                      marginTop: "0.5rem",
                      marginLeft: "1rem",
                      marginBottom: "0.8rem",
                    }}
                  >
                    <MDButton
                      color="success"
                      type="button"
                      onClick={() => handleVendorBulk("Approve")}
                    >
                      Approve
                    </MDButton>
                    <MDButton
                      color="error"
                      type="button"
                      onClick={() => handleVendorBulk("REJECT")}
                    >
                      Reject
                    </MDButton>
                  </div>
                  // )
                }
              />
            </MDBox>

            <Modal
              open={openCreateColumnReorderModal}
              onClose={handleCloseCreateColumnReorderModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
              style={{ backdropFilter: "blur(5px)" }}
            >
              <MDCard sx={styleForColumnReorder}>
                <MDTypography>Are you sure you want to submit?</MDTypography>
                <MDBox mt={2}>
                  <MDButton
                    style={{ width: "10rem", marginRight: "0.5rem" }}
                    color="info"
                    variant="outlined"
                    onClick={handleCloseCreateColumnReorderModal}
                  >
                    Cancel
                  </MDButton>
                  <MDButton
                    style={{ width: "10rem", marginLeft: "0.5rem" }}
                    color="success"
                    onClick={handleDynamicColumn}
                    // disabled={denyButtonName === "Please wait..."}
                  >
                    Submit
                  </MDButton>
                </MDBox>
                <MDBox mt={2}>
                  <Collapse in={isSuccessColumnReorder}>
                    <Alert
                      severity="success"
                      action={
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          size="small"
                          onClick={() => {
                            setIsSuccessColumnReorder(false);
                          }}
                        >
                          <CloseIcon fontSize="inherit" />
                        </IconButton>
                      }
                    >
                      Data updated successfully!
                    </Alert>
                  </Collapse>
                  <Collapse in={isErrorColumnReorder}>
                    <Alert
                      severity="error"
                      action={
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          size="small"
                          onClick={() => {
                            setIsErrorColumnReorder(false);
                          }}
                        >
                          <CloseIcon fontSize="inherit" />
                        </IconButton>
                      }
                    >
                      {isErrorMsgForColumnReorder}
                    </Alert>
                  </Collapse>
                </MDBox>
              </MDCard>
            </Modal>

            {/* Vendor Single Decision Modal */}
            <Modal
              open={openclientDecision}
              onClose={closeClientDecisionModal}
              aria-labelledby="modal-vendor-decision-title"
              aria-describedby="modal-vendor-decision-desc"
            >
              <MDCard sx={deleteStyle}>
                <MDTypography>
                  {clientDecisionType === "Approve"
                    ? "Approve this invoice?"
                    : "Reject this inv?"}
                </MDTypography>
                {clientDecisionType === "REJECT" && (
                  <MDBox mt={1}>
                    <MDTypography variant="h6">Reason (optional)</MDTypography>
                    <MDInput
                      value={rejectReason}
                      onChange={(e) => setRejectReason(e.target.value)}
                      fullWidth
                    />
                  </MDBox>
                )}
                <MDBox mt={2} display="flex">
                  <MDButton
                    style={{ width: "100%", marginRight: "0.5rem" }}
                    color="info"
                    variant="outlined"
                    onClick={closeClientDecisionModal}
                  >
                    Cancel
                  </MDButton>
                  <MDButton
                    style={{ width: "100%", marginLeft: "0.5rem" }}
                    color={
                      clientDecisionType === "Approve" ? "success" : "error"
                    }
                    onClick={confirmVendorDecision}
                  >
                    {clientDecisionType === "Approve" ? "Approve" : "Reject"}
                  </MDButton>
                </MDBox>
              </MDCard>
            </Modal>
          </Card>
        </Grid>
      </Grid>

      {loading && (
        <Backdrop
          sx={{ color: "blue", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      <ToastContainer />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
    getPurchaseOrderReducer: state.getPurchaseOrderReducer,
    unReviewInvoiceReducer: state.unReviewInvoiceReducer,

    getDynamicColumnReducer: state.getDynamicColumnReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),
    unReviewInvoice: (pageNo, rowsPerPage, searchObject, jwtToken) =>
      dispatch(unReviewInvoice(pageNo, rowsPerPage, searchObject, jwtToken)),
    rejectInvoice: (payload, jwtToken) =>
      dispatch(rejectInvoice(payload, jwtToken)),
    approveInvoice: (payload, jwtToken) =>
      dispatch(approveInvoice(payload, jwtToken)),
    getDynamicColumn: (userId, subModuleId, jwtToken) =>
      dispatch(getDynamicColumn(userId, subModuleId, jwtToken)),
    createDynamicColumn: (payload, jwtToken) =>
      dispatch(createDynamicColumn(payload, jwtToken)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PendingReview);
